import React from 'react';
import styled from 'styled-components';
import VerticalAdBanner from './AdPlaceholder';

const PageWrapper = styled.div`
  position: relative;
  min-height: calc(100vh - 60px);
  
  @media (min-width: 1200px) {
    margin-right: 180px; /* Space for the right ad banner */
  }
`;

const AdSidebar = styled.aside`
  position: fixed;
  right: 10px;
  top: 160px; /* Lower positioning for better visibility */
  width: 160px;
  height: calc(100vh - 160px);
  z-index: 10;
  
  @media (max-width: 1199px) {
    display: none;
  }
`;

const AdPageLayout = ({ children }) => {
  return (
    <>
      <PageWrapper>
        {children}
      </PageWrapper>
      <AdSidebar>
        <VerticalAdBanner />
      </AdSidebar>
    </>
  );
};

export default AdPageLayout; 